import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './styles/globals.css';

// Keep service worker only in production. In development it can serve stale assets.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('✅ Service Worker registered:', registration);

        const checkForUpdate = () => {
          registration.update().catch((error) => {
            console.warn('⚠️ Service Worker update check failed:', error);
          });
        };

        checkForUpdate();

        const handleVisibilityChange = () => {
          if (!document.hidden) {
            checkForUpdate();
          }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Check for updates periodically so the user gets the new version without a hard refresh.
        setInterval(() => {
          checkForUpdate();
        }, 300000);

        window.addEventListener('beforeunload', () => {
          document.removeEventListener('visibilitychange', handleVisibilityChange);
        }, { once: true });
      })
      .catch((error) => {
        console.warn('⚠️ Service Worker registration failed:', error);
      });
  });
} else if ('serviceWorker' in navigator && import.meta.env.DEV) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      })
      .catch((error) => {
        console.warn('⚠️ Service Worker cleanup failed in DEV:', error);
      });
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
